import {Paginazione} from "../../shared/models/paginazione";

export class FiltriTicket extends Paginazione{
  chiuso?: boolean;
  stato: number|string;
  tipo: number|string;
  constructor() {
    super(0,100);
    this.chiuso=false;
  }
}
